import { Route, Routes, Navigate } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { RequireAuth } from "@/components/RequireAuth";
import LoginPage from "@/routes/login/LoginPage";
import DashboardPage from "@/routes/dashboard/DashboardPage";
import CatalogListPage from "@/routes/catalog/CatalogListPage";
import ProductEditorPage from "@/routes/catalog/ProductEditorPage";
import OrderDetailPage from "@/routes/orders/OrderDetailPage";
import InventoryPage from "@/routes/inventory/InventoryPage";
import AnalyticsPage from "@/routes/analytics/AnalyticsPage";
import OrdersListPage from "@/routes/orders/OrdersListPage";
import { StubPage } from "@/routes/StubPage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <Shell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/catalog" element={<CatalogListPage />} />
        <Route path="/catalog/new" element={<ProductEditorPage />} />
        <Route path="/orders" element={<OrdersListPage />} />
        <Route path="/orders/:id" element={<OrderDetailPage />} />
        <Route path="/customers" element={<StubPage title="Customers" />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="*" element={<StubPage title="Not found" />} />
      </Route>
    </Routes>
  );
}
